import axios from 'axios'
import gc from '../utils/gc'
import store from '../store/index'
const baseDomain = gc.baseUrl
const baseUrl = `${baseDomain}/`
const Repositry = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: 'application/json',
    'Accept-Language': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ar',
    // 'Accept-Language': localStorage.getItem('lang'),
    Type: 'guest'
  }
})
// Repositry.interceptors.request.use(function (config) {
//   // Do something before request is sent
//   console.log('ss')
//   store.dispatch('setToken')
//   // return config
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error)
// })
Repositry.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  // console.log(response)
  return response
}, function (error) {
  if (error.response.status !== undefined) {
    if (error.response.status === 401 && localStorage.getItem('token') !== 'null') {
      if (error.response.data.status === 0) {
        store.dispatch('user/localyLogOut')
        // ms.errorMessage('Your session has been expired')
      } else if (error.response.data.status === 200) {
        // store.dispatch('user/localyLogOut')
        // store.dispatch('user/forceLogOut')
        // ms.errorMessage(error.response.data.message)
      }
    } else if (error.response.status === 403 && localStorage.getItem('token') !== 'null') {
      if (store.state.mainGsm !== '') {
        store.state.selectedNumber = store.state.mainGsm
        localStorage.setItem('selectedNum', store.state.mainGsm)
      }
      store.state.forbidden = !store.state.forbidden
    } else {
      // ms.errorMessage(error.response.data)
    }
  }
  return Promise.reject(error)
})

export default Repositry
